<template>
  <div class="floatingBanner" :style="floatingContainerStyle">
    <div
      class="icon"
      v-for="item in floating.list"
      v-show="item.icon && item.icon.trim() !== ''"
      :key="item.id"
      :style="getItemStyle(item)"
    >
      <button
        v-if="item.type === 'page' && item.pageId && item.floatingPageData"
        type="button"
        @click="setFloatingPage(item)"></button>

      <SetLink
        v-else
        :linkTarget="item"
        :lang="lang" />

      <img v-show="!isActiveFloatingPage(item) || !item.activeIcon"
        :src="item.icon"
        alt="" />

      <img v-if="item.activeIcon"
        v-show="isActiveFloatingPage(item)"
        :src="item.activeIcon"
        alt="" />
    </div>
  </div>
</template>

<script>
import SetLink from '@/components/Util/SetLink.vue'

export default {
  name: 'Floating',
  props: [
    'floating',
    'lang'
  ],
  components: {
    SetLink
  },
  computed: {
    getFloatingPage () {
      return this.$store.getters['floating/getFloatingPage']
    },

    hasActiveFloatingItem () {
      if (!this.floating || !this.floating.list || !this.floating.list.length) return false
      return this.floating.list.some(this.isActiveFloatingPage)
    },

    floatingContainerStyle () {
      const style = this.hasActiveFloatingItem
        ? this.getActiveBannerStyle()
        : this.getBaseBannerStyle()
      const container = this.getContainerStyle(style)

      container.alignItems = style.positionX === 'left'
        ? 'flex-start'
        : 'flex-end'

      return container
    }
  },
  methods: {
    // -------------------------
    // payload resolver
    // -------------------------
    getBaseBannerStyle () {
      const floating = this.floating || {}
      const bannerStyle = floating.bannerStyle || {}
      const legacyStyle = floating.style || {}

      return {
        positionX: bannerStyle.positionX || floating.position || 'right',
        positionY: bannerStyle.positionY || 'bottom',
        axisY: typeof bannerStyle.axisY !== 'undefined'
          ? bannerStyle.axisY
          : !!legacyStyle.axisY,
        marginX: typeof bannerStyle.marginX !== 'undefined'
          ? bannerStyle.marginX
          : (typeof legacyStyle.positionLeftRight !== 'undefined' ? String(legacyStyle.positionLeftRight) : '15'),
        marginY: typeof bannerStyle.marginY !== 'undefined'
          ? bannerStyle.marginY
          : (typeof legacyStyle.positionBottom !== 'undefined' ? String(legacyStyle.positionBottom) : '15'),
        size: typeof bannerStyle.size !== 'undefined'
          ? bannerStyle.size
          : (typeof legacyStyle.size !== 'undefined' ? String(legacyStyle.size) : '60')
      }
    },

    getActiveBannerStyle () {
      const floating = this.floating || {}
      const activeStyle = floating.bannerActiveStyle || {}
      const baseStyle = this.getBaseBannerStyle()

      return {
        positionX: activeStyle.positionX || baseStyle.positionX,
        positionY: activeStyle.positionY || baseStyle.positionY,
        axisY: typeof activeStyle.axisY !== 'undefined'
          ? activeStyle.axisY
          : baseStyle.axisY,
        marginX: typeof activeStyle.marginX !== 'undefined'
          ? activeStyle.marginX
          : baseStyle.marginX,
        marginY: typeof activeStyle.marginY !== 'undefined'
          ? activeStyle.marginY
          : baseStyle.marginY,
        size: typeof activeStyle.size !== 'undefined'
          ? activeStyle.size
          : baseStyle.size
      }
    },

    getResolvedBannerStyle (item) {
      return this.isActiveFloatingPage(item)
        ? this.getActiveBannerStyle()
        : this.getBaseBannerStyle()
    },

    // -------------------------
    // style builder
    // -------------------------
    getContainerStyle (style) {
      const positionX = style.positionX || 'right'
      const positionY = style.positionY || 'bottom'
      const otherPositionX = positionX === 'right' ? 'left' : 'right'
      const otherPositionY = positionY === 'bottom' ? 'top' : 'bottom'

      const result = {}
      result[positionX] = `${String(style.marginX || '15')}px`
      result[otherPositionX] = 'auto'
      result[positionY] = `${String(style.marginY || '15')}px`
      result[otherPositionY] = 'auto'

      return result
    },

    getItemStyle (item) {
      const style = this.getResolvedBannerStyle(item)
      const axis = style.axisY ? 'height' : 'width'

      const result = {}
      result[axis] = String(style.size || '60') + 'px'

      return result
    },

    // -------------------------
    // existing logic
    // -------------------------
    isActiveFloatingPage (item) {
      const isPage = item.type === 'page' && item.pageId
      const isShop = item.type === 'shop' && item.shopPageId
      const isProduct = item.type === 'product' && item.productId
      const isReservation = item.type === 'reservation' && item.reservationId

      if (item.floatingPageData && item.floatingPageData.isFloatingPage) {
        const currentFloatingPageId = this.getFloatingPage
        return currentFloatingPageId === item.pageId
      }

      return isPage && this.$route.name === 'page' && this.$route.params.id === item.pageId ||
        isShop && (this.$route.name === 'shop' || this.$route.name === 'store') && this.$route.params.shopPageId === item.shopPageId ||
        isProduct && this.$route.name === 'product' && this.$route.params.productId === item.productId ||
        isReservation && this.$route.name === 'reservation' && this.$route.params.reservationId === item.reservationId
    },

    setFloatingPage (item) {
      if (item.floatingPageData && item.floatingPageData.isFloatingPage) {
        this.$store.commit('floating/setFloatingPage', {
          pageId: item.pageId,
          style: item.floatingPageData
        })
      }
    },

    getIcon (item) {
      if (this.isActiveFloatingPage(item) && item.activeIcon) {
        return item.activeIcon
      }
      return item.icon
    }
  }
}
</script>